import angular from 'angular';
// {"url":"url_completa","key":"campo"(optional),"text":"campo"(optional),"headers":{}}

/**
 * Controla la tabla de inspecciones.
 */
CamposExtraListApiCtrl.$inject = ['$http', 'dialogService', '$filter'];

export default function CamposExtraListApiCtrl($http, dialogService, $filter) {

    var campExtListApi = this;

    campExtListApi.claseRow = issetAndNotEmpty(campExtListApi.claseRow) ? campExtListApi.claseRow == 'true' : true;
    var teniaValor = campExtListApi.campoExtra.valor !== null && campExtListApi.campoExtra.valor.length > 0;

    var DIALOG_AUTOCOMPLETE_TEMPLATE = require('./dialog-autocomplete/dialog-autocomplete.html');

    campExtListApi.jsonOptions = angular.fromJson(campExtListApi.campoExtra.json);

    campExtListApi.hasError = false;
    campExtListApi.updateError = false;
    campExtListApi.loading = false;

    campExtListApi.options = [];
    campExtListApi.optionSelected = null;

    if (campExtListApi.campoExtra.valor != null)
        campExtListApi.optionSelected = JSON.parse(campExtListApi.campoExtra.valor_json);

    campExtListApi.edit = function () {
        var titulo = campExtListApi.campoExtra.nombre;
        var options = {title: titulo};
        var datos = {
            campoExtra: campExtListApi.jsonOptions,
            campoExtraValor: campExtListApi.campoExtra.valor,
            id_model: campExtListApi.modelId
        };

        var opcionesExtra = {deshabilitarBotones: true};

        dialogService.open("dialog-auto-complete", DIALOG_AUTOCOMPLETE_TEMPLATE, datos, options, opcionesExtra).then(
            function (res) {
                var selected = res;

                campExtListApi.campoExtra.valor = campExtListApi.valueOption(selected);
                campExtListApi.campoExtra.valor_descripcion = campExtListApi.textOption(selected);
                campExtListApi.campoExtra.valor_json = JSON.stringify(selected);

                campExtListApi.optionSelected = selected;
                campExtListApi.validate();
            }
        );
    };

    campExtListApi.validate = function () {
        if (issetAndNotEmpty(campExtListApi.campoExtra.valor)) {
            campExtListApi.hasError = false;
            campExtListApi.campoExtra.changed = true;
        } else if (teniaValor) {
            campExtListApi.hasError = true;
            campExtListApi.campoExtra.changed = false;
        }
    };

    campExtListApi.borrar = function () {
        campExtListApi.campoExtra.valor = null;
        campExtListApi.campoExtra.valor_descripcion = null;
        campExtListApi.campoExtra.valor_json = null;
        campExtListApi.campoExtra.changed = true;
        campExtListApi.optionSelected = null;
    };

    campExtListApi.valueOption = function (option) {
        return option[campExtListApi.jsonOptions.key];
    };

    campExtListApi.textOption = function (option) {
        return option[campExtListApi.jsonOptions.text] + " " + option[campExtListApi.jsonOptions.descrip];
    };

    campExtListApi.printCurrentValue = function () {
        if (campExtListApi.optionSelected == null) {
            return $filter('capitalize')($filter('lang')('nombres.sin_valor', 'get'));
        }

        return campExtListApi.textOption(campExtListApi.optionSelected);
    };
}